export default "__VITE_ASSET__DgJldIih__"